import { pipe, map, sum } from 'ramda';
import StatsService from '../services/StatsService';
import { defaultErrorHandler } from './';

export default {
  state: {
    stats: { contestStats: { perUser: []}}
  },

  getters: {
    pollStats: state => state.stats,

    statsOfSelectedQuestion: (state, getters, rootState) => {
      const selectedQuestionId = rootState.question.selectedQuestionId;
      const answers = (state.stats.answers || []).filter(answer => {
        return answer.questionId === selectedQuestionId;
      });
      const totalVoteCount = pipe(
        map(answer => answer.voteCount),
        sum
      )(answers);
      return {
        totalVoteCount,
        answers
      };
    }
  },

  mutations: {
    SET_STATS(state, stats) {
      state.stats = stats;
    }
  },

  actions: {
    fetchStatsOfPoll: ({ commit }, { pollId }) => {
      StatsService.findOfPoll(pollId)
        .then(stats => {
          commit('SET_STATS', stats);
        })
        .catch(defaultErrorHandler);
    }
  }
};
